import React from 'react';
import {
  HistoryIcon,
  FileTextIcon,
  UserIcon,
} from './common/Icons';

interface UserDashboardProps {
  userName?: string;
}

/**
 * Basic user dashboard — Welcome + Quick Stats + Recent Activity + Quick Actions.
 *
 * Used as the default content when a user has no template navigation groups
 * (e.g., Default Org with no template assigned).
 *
 * Extracted from UserPortal.tsx for shared use in the unified Portal (WQ-076).
 */
const UserDashboard: React.FC<UserDashboardProps> = ({ userName }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Welcome, {userName || 'User'}</h1>
        <p className="page-subtitle">Your personal dashboard</p>
      </div>

      <div className="dashboard-grid">
        {/* Quick Stats */}
        <div className="card card-elevated">
          <div className="card-header">
            <h3>Quick Stats</h3>
          </div>
          <div className="card-body">
            <div className="stats-grid">
              <div className="stat-item">
                <span className="stat-value">12</span>
                <span className="stat-label">Conversations</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">45</span>
                <span className="stat-label">Messages Today</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">3</span>
                <span className="stat-label">Active Sessions</span>
              </div>
            </div>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="card card-elevated">
          <div className="card-header">
            <h3>Recent Activity</h3>
          </div>
          <div className="card-body">
            <div className="activity-list">
              <div className="activity-item">
                <span className="activity-icon"><HistoryIcon size={16} /></span>
                <div className="activity-content">
                  <span className="activity-title">Chat conversation</span>
                  <span className="activity-time">2 hours ago</span>
                </div>
              </div>
              <div className="activity-item">
                <span className="activity-icon"><UserIcon size={16} /></span>
                <div className="activity-content">
                  <span className="activity-title">Profile updated</span>
                  <span className="activity-time">Yesterday</span>
                </div>
              </div>
              <div className="activity-item">
                <span className="activity-icon"><FileTextIcon size={16} /></span>
                <div className="activity-content">
                  <span className="activity-title">Document viewed</span>
                  <span className="activity-time">2 days ago</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="card card-elevated">
          <div className="card-header">
            <h3>Quick Actions</h3>
          </div>
          <div className="card-body">
            <div className="quick-actions">
              <button className="btn btn-primary">
                Start New Chat
              </button>
              <button className="btn btn-secondary">
                View History
              </button>
              <button className="btn btn-secondary">
                Browse Docs
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;
